export const POSTCODE = 'postcode'
import Cookies from 'js-cookie'
import { ListingType } from '../__generated__/fed-graphql-types'

export const setPostcodeCookie = (postcode: string) => {
    Cookies.set(POSTCODE, postcode)
}

const listingTypes = new Map()
listingTypes.set(ListingType.FEATURED_LISTING, 'featured-listing')
listingTypes.set(ListingType.PROMOTED_LISTING, 'promoted')
listingTypes.set(ListingType.YOU_MAY_ALSO_LIKE, 'ymal')
listingTypes.set(ListingType.LEASING_LISTING, 'ls')
listingTypes.set(ListingType.NATURAL_LISTING, 'STANDARD_ADVERT')

export const setSearchJourneyCookie = (type?: ListingType, advertId?: string) => {
    const cookieExpiry = 10 / 86400 // 10 seconds
    const listingType = listingTypes.get(type)
    const searchJourneyValue = advertId ? `${listingType}__${advertId}` : listingType
    Cookies.set('searchJourney', searchJourneyValue, { expires: cookieExpiry })
}
